(ns manatee.routing.app-db)

(def routes-path [:routes])

(defn set-routes
  [db routes]
  (assoc-in db routes-path routes))

(defn get-all-routes
  [db]
  (get-in db routes-path))

(defn get-routes
  [db service-name]
  (get-in db (conj routes-path service-name)))
